(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-feature-blocks"] && !Shopify.designMode) return;
  try {
    
(function() {
  // console.log('--- READ MORE SCRIPT V2: STARTING ---'); // Keep one distinct top-level log

  const sectionType = 'image-feature-blocks-read-more';

  function debounce(func, wait, immediate) {
      var timeout;
      return function() {
          var context = this, args = arguments;
          var later = function() {
              timeout = null;
              if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
      };
  };

  function initializeSection(containerElement) {
    const sectionId = containerElement.dataset.sectionId;
    if (!sectionId) {
        // console.error('--- READ MORE SCRIPT V2: ERROR - Container missing data-section-id', containerElement);
        return;
    }
    // console.log(`--- READ MORE SCRIPT V2: Initializing Section ID: ${sectionId}`);

    const selectors = {
        item: '.image-feature-blocks__item',
        content: '[data-read-more-content]',
        button: '[data-read-more-button]',
        truncatedClass: 'rte--truncated',
        expandedClass: 'rte--expanded'
    };

    function toggleReadMore(contentElement, buttonElement) {
        const isExpanded = contentElement.classList.contains(selectors.expandedClass);
        // console.log(`Read More JS V2 Toggle (${contentElement.id}): Currently expanded = ${isExpanded}`);
        if (isExpanded) {
            contentElement.classList.remove(selectors.expandedClass);
            contentElement.classList.add(selectors.truncatedClass);
            buttonElement.setAttribute('aria-expanded', 'false');
            buttonElement.textContent = buttonElement.dataset.textCollapsed;
        } else {
            contentElement.classList.add(selectors.expandedClass);
            contentElement.classList.remove(selectors.truncatedClass);
            buttonElement.setAttribute('aria-expanded', 'true');
            buttonElement.textContent = buttonElement.dataset.textExpanded;
        }
    }

    function initReadMoreBlock(blockElement) {
        const contentElement = blockElement.querySelector(selectors.content);
        const buttonElement = blockElement.querySelector(selectors.button);

        if (!contentElement || !buttonElement) {
            // console.warn(`Read More JS V2 (${sectionId}): Content or button missing in block:`, blockElement);
            return;
        }
        // console.log(`Read More JS V2 (${sectionId}): Setting up block ${contentElement.id}`);

        const toggleHandler = () => toggleReadMore(contentElement, buttonElement);

        const checkOverflow = () => {
            contentElement.classList.add(selectors.truncatedClass); // Ensure it's truncated to measure correctly
            contentElement.classList.remove(selectors.expandedClass);
            buttonElement.setAttribute('aria-expanded', 'false');
            buttonElement.textContent = buttonElement.dataset.textCollapsed;
            void contentElement.offsetHeight; // Force reflow

            const currentScrollHeight = contentElement.scrollHeight;
            const currentClientHeight = contentElement.clientHeight;
            const isOverflowing = currentScrollHeight > (currentClientHeight + 1); // +1 for subpixel rendering buffer

            // console.log(`Read More JS V2 Check (${contentElement.id}): scrollH=${currentScrollHeight}, clientH=${currentClientHeight}, Overflowing=${isOverflowing}`);
            
            if (isOverflowing) {
                // console.log(`Read More JS V2 Check (${contentElement.id}): Overflow detected, showing button.`);
                buttonElement.style.display = 'inline-block';
                buttonElement.removeEventListener('click', toggleHandler); // Remove to prevent duplicates
                buttonElement.addEventListener('click', toggleHandler);
            } else {
                // console.log(`Read More JS V2 Check (${contentElement.id}): No overflow, hiding button.`);
                buttonElement.style.display = 'none';
                contentElement.classList.remove(selectors.truncatedClass); // Not needed if no overflow
                buttonElement.removeEventListener('click', toggleHandler);
            }
        };
        
        setTimeout(checkOverflow, 150); // Delay to allow content to render, especially images
        // If you have images inside the content that affect height, consider using an image load event listener
        // or a more robust resize observer for `checkOverflow`. For text, setTimeout is usually okay.
    }

    const blocks = containerElement.querySelectorAll(selectors.item);
    // console.log(`Read More JS V2 (${sectionId}): Found ${blocks.length} blocks.`);
    blocks.forEach(initReadMoreBlock);
  }

  function initializeAllSections() {
    // console.log(`--- READ MORE SCRIPT V2: Searching for sections with type: ${sectionType}`);
    const sectionElements = document.querySelectorAll(`[data-section-type="${sectionType}"]`);
    // console.log(`--- READ MORE SCRIPT V2: Found ${sectionElements.length} matching section(s).`);
    if (sectionElements.length === 0) {
         // console.warn(`--- READ MORE SCRIPT V2: No sections found with data-section-type="${sectionType}".`);
         return;
    }
    sectionElements.forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllSections);
  } else {
    initializeAllSections();
  }

  if (Shopify.designMode) {
    // console.log(`--- READ MORE SCRIPT V2: Attaching Shopify editor listeners.`);
    document.addEventListener('shopify:section:load', function(event) {
        if (event.target.dataset.sectionType === sectionType) {
            // console.log(`--- READ MORE SCRIPT V2: Shopify section:load event for matching section ${event.detail.sectionId}. Initializing.`);
            initializeSection(event.target);
        }
    });
    const handleEditorUpdate = debounce((event) => {
        const updatedSectionElement = event.target.closest(`[data-section-type="${sectionType}"]`);
        if (updatedSectionElement) {
            // console.log(`--- READ MORE SCRIPT V2: Shopify editor event (${event.type}) detected. Re-initializing section ${updatedSectionElement.dataset.sectionId}.`);
            initializeSection(updatedSectionElement);
        }
    }, 350); // Increased debounce slightly for editor stability
    document.addEventListener('shopify:block:add', handleEditorUpdate);
    document.addEventListener('shopify:block:remove', handleEditorUpdate);
    document.addEventListener('shopify:block:select', handleEditorUpdate);
    document.addEventListener('shopify:block:deselect', handleEditorUpdate);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-detail-items"] && !Shopify.designMode) return;
  try {
    
(function() { const sectionType = 'image-detail-items-read-more'; class ReadMoreHandler { constructor(containerElement) { this.container = containerElement; this.sectionId = this.container.dataset.sectionId; this.truncateEnabled = this.container.dataset.truncateEnabled === 'true'; if (!this.sectionId || !this.truncateEnabled) { return; } this.contentElement = this.container.querySelector('[data-read-more-content]'); this.buttonElement = this.container.querySelector('[data-read-more-button]'); if (!this.contentElement || !this.buttonElement) { console.warn(`Read More (${this.sectionId}): Content or button element not found.`); return; } this.selectors = { truncatedClass: 'rte--truncated', expandedClass: 'rte--expanded' }; this.init(); } init() { this.checkOverflowAndBind(); this.buttonElement.addEventListener('click', this.toggleReadMore.bind(this)); } checkOverflowAndBind() { this.contentElement.classList.remove(this.selectors.truncatedClass, this.selectors.expandedClass); this.buttonElement.style.display = 'none'; requestAnimationFrame(() => { setTimeout(() => { const naturalHeight = this.contentElement.scrollHeight; this.contentElement.classList.add(this.selectors.truncatedClass); void this.contentElement.offsetHeight; const clampedHeight = this.contentElement.clientHeight; this.contentElement.classList.remove(this.selectors.truncatedClass); const isOverflowing = naturalHeight > (clampedHeight + 2); if (isOverflowing) { this.contentElement.classList.add(this.selectors.truncatedClass); this.buttonElement.style.display = 'inline-block'; this.buttonElement.setAttribute('aria-expanded', 'false'); this.buttonElement.textContent = this.buttonElement.dataset.textCollapsed; } else { this.contentElement.classList.remove(this.selectors.truncatedClass, this.selectors.expandedClass); this.buttonElement.style.display = 'none'; } }, 50); }); } toggleReadMore() { const isExpanded = this.contentElement.classList.contains(this.selectors.expandedClass); if (isExpanded) { this.contentElement.classList.remove(this.selectors.expandedClass); this.contentElement.classList.add(this.selectors.truncatedClass); this.buttonElement.setAttribute('aria-expanded', 'false'); this.buttonElement.textContent = this.buttonElement.dataset.textCollapsed; } else { this.contentElement.classList.add(this.selectors.expandedClass); this.contentElement.classList.remove(this.selectors.truncatedClass); this.buttonElement.setAttribute('aria-expanded', 'true'); this.buttonElement.textContent = this.buttonElement.dataset.textExpanded; } } } function initializeAllSections() { const sectionElements = document.querySelectorAll(`[data-section-type="${sectionType}"]`); sectionElements.forEach(container => { if (!container.dataset.readMoreInitialized) { new ReadMoreHandler(container); container.dataset.readMoreInitialized = true; } }); } if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initializeAllSections); } else { initializeAllSections(); } if (Shopify.designMode) { const initializeSpecificSection = (container) => { if (container && container.matches(`[data-section-type="${sectionType}"]`)) { delete container.dataset.readMoreInitialized; new ReadMoreHandler(container); container.dataset.readMoreInitialized = true; } }; document.addEventListener('shopify:section:load', (event) => initializeSpecificSection(document.querySelector(`[data-section-id="${event.detail.sectionId}"]`))); document.addEventListener('shopify:section:select', (event) => initializeSpecificSection(document.getElementById(`shopify-section-${event.detail.sectionId}`))); document.addEventListener('shopify:section:deselect', (event) => initializeSpecificSection(document.getElementById(`shopify-section-${event.detail.sectionId}`))); const handleBlockChange = () => { document.querySelectorAll(`[data-section-type="${sectionType}"]`).forEach(container => delete container.dataset.readMoreInitialized); initializeAllSections(); }; document.addEventListener('shopify:block:add', handleBlockChange); document.addEventListener('shopify:block:remove', handleBlockChange); } })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
// Using IIFE to encapsulate scope
(function() {
  const sectionType = 'image-with-text-read-more';

  class ReadMoreBlockHandler {
    constructor(blockElement) {
      this.blockElement = blockElement; // .read-more-wrapper div
      this.blockId = this.blockElement.dataset.blockId;
      this.sectionContainer = this.blockElement.closest('[data-section-id]');
      this.sectionId = this.sectionContainer ? this.sectionContainer.dataset.sectionId : null;
      this.truncateEnabled = this.blockElement.dataset.readMoreEnabled === 'true';

      if (!this.blockId || !this.sectionId || !this.truncateEnabled) { return; }

      this.contentElement = this.blockElement.querySelector('[data-read-more-content]');
      this.buttonElement = this.blockElement.querySelector('[data-read-more-button]');

      if (!this.contentElement || !this.buttonElement) { console.warn(`Read More (${this.sectionId}-${this.blockId}): Content or button element not found.`); return; }

      this.selectors = { truncatedClass: 'rte--truncated', expandedClass: 'rte--expanded' };
      this.init();
    }

    init() {
      this.checkOverflowAndBind();
      this.buttonElement.removeEventListener('click', this.toggleReadMore.bind(this));
      this.buttonElement.addEventListener('click', this.toggleReadMore.bind(this));
    }

    checkOverflowAndBind() {
      this.contentElement.classList.remove(this.selectors.truncatedClass, this.selectors.expandedClass);
      this.buttonElement.style.display = 'none';
      requestAnimationFrame(() => {
        setTimeout(() => {
           if (!this.contentElement || !document.body.contains(this.contentElement)) { return; }
           const naturalHeight = this.contentElement.scrollHeight;
           this.contentElement.classList.add(this.selectors.truncatedClass);
           void this.contentElement.offsetHeight;
           const clampedHeight = this.contentElement.clientHeight;
           this.contentElement.classList.remove(this.selectors.truncatedClass);
           const isOverflowing = naturalHeight > (clampedHeight + 2);
           if (isOverflowing) {
             this.contentElement.classList.add(this.selectors.truncatedClass);
             this.buttonElement.style.display = 'inline-block';
             this.buttonElement.setAttribute('aria-expanded', 'false');
             this.buttonElement.textContent = this.buttonElement.dataset.textCollapsed;
           } else {
             this.contentElement.classList.remove(this.selectors.truncatedClass, this.selectors.expandedClass);
             this.buttonElement.style.display = 'none';
           }
        }, 50);
      });
    }

    toggleReadMore() {
      const isExpanded = this.contentElement.classList.toggle(this.selectors.expandedClass);
      this.contentElement.classList.toggle(this.selectors.truncatedClass, !isExpanded);
      this.buttonElement.setAttribute('aria-expanded', isExpanded);
      this.buttonElement.textContent = isExpanded ? this.buttonElement.dataset.textExpanded : this.buttonElement.dataset.textCollapsed;
    }
  } // End Class

  function initializeSection(sectionContainer) {
      const sectionId = sectionContainer.dataset.sectionId;
      const blockElements = sectionContainer.querySelectorAll('.read-more-wrapper[data-read-more-enabled="true"]');
      blockElements.forEach(blockElement => {
          if (!blockElement.dataset.readMoreInitialized) {
              new ReadMoreBlockHandler(blockElement);
              blockElement.dataset.readMoreInitialized = 'true';
          }
      });
  }

  function initializeAllSections() {
    document.querySelectorAll(`[data-section-type="${sectionType}"]`).forEach(initializeSection);
  }

  // Initial load
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initializeAllSections); } else { initializeAllSections(); }

  // Shopify Editor Integration
  if (Shopify.designMode) {
    const reinitializeAppSpecificSection = (sectionId) => {
        const container = document.querySelector(`[data-section-id="${sectionId}"][data-section-type="${sectionType}"]`);
        if (container) {
            container.querySelectorAll('.read-more-wrapper[data-read-more-enabled="true"]').forEach(block => { delete block.dataset.readMoreInitialized; });
            initializeSection(container);
        }
    };
    document.addEventListener('shopify:section:load', (event) => reinitializeAppSpecificSection(event.detail.sectionId));
    document.addEventListener('shopify:block:select', (event) => reinitializeAppSpecificSection(event.detail.sectionId));
    document.addEventListener('shopify:block:deselect', (event) => reinitializeAppSpecificSection(event.detail.sectionId));
    document.addEventListener('shopify:block:add', (event) => reinitializeAppSpecificSection(event.detail.sectionId));
    document.addEventListener('shopify:block:remove', (event) => reinitializeAppSpecificSection(event.detail.sectionId));
  }

})(); // End IIFE

  } catch(e) { console.error(e); }
})();
})();
